// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Platform_SiteUnitsListInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /platform/v1/site_units — the resource's `list_filters`
 * (contracts/platform/resources/site_unit.yml). Both optional; any other query key is
 * refused (`filtro_invalido:<chave>`, 400), never silently ignored.
 */
import { registerContract } from './validate'

export interface Platform_SiteUnitsListInput {
status?: string
franchise_id?: number
}

registerContract('Platform_SiteUnitsListInput', {
  status:       { type: 'string',  required: false },
  franchise_id: { type: 'number',  required: false },
})
